import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	componentName: {
		id: 'project-components.edit-modal-dialog-component-name-label',
		defaultMessage: 'Name',
		description: '',
	},
	componentLead: {
		id: 'project-components.edit-modal-dialog-component-lead-label',
		defaultMessage: 'Component lead',
		description: '',
	},
	componentLeadPlaceholder: {
		id: 'project-components.edit-modal-dialog-component-lead-placeholder',
		defaultMessage: 'Select person',
		description: '',
	},
	description: {
		id: 'project-components.edit-modal-dialog-description-label',
		defaultMessage: 'Description',
		description: '',
	},
	defaultAssignee: {
		id: 'project-components.edit-modal-dialog-default-assignee-label',
		defaultMessage: 'Default assignee',
		description: '',
	},
	deactivated: {
		id: 'project-components.edit-modal-dialog-deactivated-status-label',
		defaultMessage: '{userName} (Deactivated)',
		description:
			'Text displayed to the right of the user name of a deactivated user in user picker field',
	},
	requiredFieldsInformMessage: {
		id: 'project-components.edit-modal-dialog-required-field-inform-text-message',
		defaultMessage: 'Required fields are marked with an asterisk',
		description: 'Message to give information to users about required fields',
	},
});
